import { useValibotFieldSingle } from '~/components/valibot/ValibotForm';
import InputTextarea, { InputTextareaProps } from '~/components/input/InputTextarea';

export default function ValibotFieldTextarea({
  name,
  ...props
}: Omit<InputTextareaProps, 'onChange' | 'value'> & { name: string }) {
  const [prefixed, value, setValue] = useValibotFieldSingle(name);

  return <InputTextarea {...props} name={prefixed} value={value ?? ''} onChange={(value) => setValue(value || '')} />;
}
